import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { Test1Component } from './test1/test1.component';
import { Test2Component } from './test2/test2.component';
import { GViewerComponent } from './maps/gmaps/gviewer.component';
import { DeliveryConfirmComponent } from './delivery-confirm/delivery-confirm.component';


const routes: Routes = [
	{
		path: 'test1/:bidId',
		component: Test1Component
	},
	{
		path: 'test2/:bidId',
		component: Test2Component
	},
	{
		path: 'map/gmaps/gviewer',
		component: GViewerComponent
	},
	{
		path: 'delivery/confirm/:chid',
		component: DeliveryConfirmComponent
	}
];


@NgModule({
	declarations: [],
	imports: [
		RouterModule.forChild(routes),
	],
	exports: [RouterModule]
})
export class AppPublicRoutingModule { }
